import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchManagedModalContent: DocumentNode = gql`
  query FetchManagedModalContent($storyId: String!, $version: String!, $relations: String) {
    fetchManagedModalContent(storyId: $storyId, version: $version, relations: $relations) {
      ... on ManagedModalContent {
        cv
        story {
          slug
          content {
            body
            component
            ctaText
            ctaLink {
              url
              hostname
            }
            heading
            image {
              filename
            }
            linkHostname
          }
        }
        rels
      }
    }
  }
`

export default fetchManagedModalContent
